export const SET_ACCRUALS_HISTORY = 'SET_ACCRUALS_HISTORY'
export const RESET_ACCRUALS_PAYMENTS = 'RESET_ACCRUALS_PAYMENTS'
